export enum BooleanFormType {
  TRUE = "true",
  FALSE = "false",
}
